import { Attachment } from "@docma-mm-core/attachment/attachment";
import { Task } from "@mydocma/task";
import { Observable } from "rxjs";

type AttachmentEntry = {
  attachment: Attachment;
  activityUid?: string;
};

type FaultAttachmentEntry = {
  attachments: AttachmentEntry[];
  mydocmaUid: string;
};
export class AttachmentDownloadJob {

    public attachments = new Map<string, FaultAttachmentEntry>();
    public task: Task;
    public onTaskCanceled: Observable<boolean>;

    public failedFaultUIds = new Set<string>();

    public openMessageCenter: boolean = false;

    constructor(mydocmaUid: string) {}

    addAttachment(faultUId: string, a: Attachment, mydocmaUid: string, activityUid?: string) {
        let faultAttachments = this.attachments.get(faultUId);
        if (!faultAttachments) {
            faultAttachments = {attachments: [], mydocmaUid};
            this.attachments.set(faultUId, faultAttachments);
        }
        faultAttachments.attachments.push({ attachment: a, activityUid });
    }

    markFaultAsFailed(faultUId: string) {
        this.failedFaultUIds.add(faultUId);
    }

    get failedCount(): number {
        return this.failedFaultUIds.size;
    }

    get totalCount(): number {
        return this.attachments.size;
    }
}